import React from 'react';
import { Box, Typography } from '@mui/material';
import { VaultItemDTO } from '../../types';
import { createColouredGlassSurface, createParchmentLabelSurface, hashStringToSeed } from '../../theme/surfaces';
import { VaultItemActionMenu } from './VaultItemActionMenu';

interface PotionCardProps {
  item: VaultItemDTO;
  memberNameById: Map<string, string>;
  onDiscard: (instanceId: string) => void;
  onSell?: (instanceId: string) => void;
}

export const PotionCard: React.FC<PotionCardProps> = React.memo(function PotionCard({
  item,
  memberNameById,
  onDiscard,
  onSell,
}) {
  const surfaceSx = React.useMemo(
    () => ({ ...createColouredGlassSurface(hashStringToSeed(item.id)), maxWidth: '300px' }),
    [item.id],
  );

  const parchmentLabelSx = React.useMemo(
    () => createParchmentLabelSurface(hashStringToSeed(item.id)),
    [item.id],
  );

  return (
    <Box sx={{ height: '100%', ...surfaceSx }} p={1.5} mt={6}>
      <Box sx={{ py: 1.5, '&:last-child': { pb: 1.5 }, display: 'flex', justifyContent: 'center', alignItems: 'flex-start', position: 'relative' }}>
        <Box sx={{ ...parchmentLabelSx, maxWidth: '70%' }}>
          <Typography variant="subtitle2">{item.name}</Typography>
          {item.description && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
              {item.description}
            </Typography>
          )}
          {item.salePrice > 0 && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
              Sale: {item.salePrice}gc
            </Typography>
          )}
          {item.warbandMemberId && memberNameById.get(item.warbandMemberId) && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5, fontStyle: 'italic' }}>
              Used by: {memberNameById.get(item.warbandMemberId)}
            </Typography>
          )}
        </Box>
        <VaultItemActionMenu
          itemName={item.name}
          instanceId={item.instanceId!}
          salePrice={item.salePrice}
          onDiscard={onDiscard}
          onSell={onSell}
          buttonSx={{ position: 'absolute', top: 0, right: 0 }}
        />
      </Box>
    </Box>
  );
});
